__turbopack_context__.v({
  "container": "NavbarOutletSearch-module-scss-module__BtvdIG__container",
  "hasPreOrderCheckout": "NavbarOutletSearch-module-scss-module__BtvdIG__hasPreOrderCheckout",
  "navBarSearch": "NavbarOutletSearch-module-scss-module__BtvdIG__navBarSearch",
  "outletDetailsPage": "NavbarOutletSearch-module-scss-module__BtvdIG__outletDetailsPage",
  "spinner": "NavbarOutletSearch-module-scss-module__BtvdIG__spinner",
  "whiteLabeled": "NavbarOutletSearch-module-scss-module__BtvdIG__whiteLabeled",
});
